import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "8c27c140-23d8-434b-8ab8-0691b4b796bc",
    content: "Loudness",
    options: {},
  },
  {
    id: "ac7464cb-a7ec-410c-8f7b-52140b964d9f",
    content: "Roughness",
    options: {},
  },
  {
    id: "b58eb90e-3dce-45cc-9749-57bb7ff01625",
    content: "Tonality",
    options: {},
  },
  {
    id: "6509362b-53da-4970-bcfa-a2a15f45a4b7",
    content: "Fluctuation Strength",
    options: {},
  },
  {
    id: "714e0aca-2cb7-4c7d-8f0c-6b2b53bc966c",
    content: "SPL",
    options: {},
  },
  {
    id: "e795c9af-9888-4cfc-ba4f-81a4a4b26afb",
    content: "A-Weighted SPL",
    options: {},
  },
];

export const task: Task = {
  id: "c6ea9b8f-0b42-422b-b814-413c53bb0f7b",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8c27c140-23d8-434b-8ab8-0691b4b796bc"],
};
